// Copyright 2026 Zibby Lab. Apache-2.0.
//
// LetterAvatar — a generated initial-letter avatar: the name's first character
// on a deterministic colored rounded square. Used wherever there's no real logo
// (custom workflows with no marketplace template, projects). Same name → same
// color across renders/reloads. Atomic + shared so the Pipelines list and the
// Projects list (and anywhere else) render an identical placeholder.

import React from 'react';
import PropTypes from 'prop-types';
import './LetterAvatar.css';

// Deterministic hue from the name so the color is stable per name.
const hueFromName = (s) => {
  let h = 0;
  for (let i = 0; i < (s || '').length; i += 1) h = (h * 31 + s.charCodeAt(i)) % 360;
  return h;
};

export default function LetterAvatar({ name, className = '', title }) {
  const letter = ((name || '?').trim().charAt(0) || '?').toUpperCase();
  return (
    <span
      className={`letter-avatar ${className}`.trim()}
      style={{ background: `hsl(${hueFromName(name)} 45% 32%)` }}
      title={title}
      aria-hidden="true"
    >
      {letter}
    </span>
  );
}

LetterAvatar.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  // Optional hover tooltip (e.g. the member agent's display name in the
  // composite-agent member strip). Omitted → no title attribute.
  title: PropTypes.string,
};
